












import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

import SdsBreadcrumbItem from './SdsBreadcrumbItem.vue';

import type { BreadcrumbItem } from './types';

// @TODO: Should we trap focus inside of this when it's open?
// @TODO: Any zIndex troubles? Should we have global overlay layer and absolutely position these overlays?

export default defineComponent({
    name: 'SdsBreadcrumbsDropdownBox',
    props: {
        items: {
            type: Array as PropType<BreadcrumbItem[]>,
            required: true,
        },
    },
    components: {
        SdsBreadcrumbItem,
    },
});
